export default "__VITE_ASSET__553baf2c__"